import React from "react";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";

const VillaContainer = styled.div`
    padding: 1em;
    flex: 1 1 33%;
    position: relative;

    @media (max-width:992px){
        margin-bottom: 2em;
        width:100%;
        flex:auto;
    }

    @media (max-width:767px){
        padding: 0;
    }
`;

const VillaImage = styled.img`
    width: 100%;
    height:auto;
    display:block;
`;

const VillaTitleLink = styled.a`
    font-size:130%;
    
    @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px) 
    and (orientation : portrait) { 
        font-size:100%;
    }
`;

const BackDrop = styled.div`
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.1);
`;

const AbsoluteContent = styled.div`
    position:absolute;
    bottom: 1em;
    left: 1em;
`;

class VillaCategoryHolderComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        const { title, image, count, link , t} = this.props;

        return (
            <VillaContainer>
                <div className="relative">
                    <VillaImage src={image} alt={title} className="border-radius-default"/>
                    <a href={link}><BackDrop /></a>
                    <AbsoluteContent>
                        <div><VillaTitleLink href={link} className="white font-w600 text-shadow-blue1">{title}</VillaTitleLink></div>
                        <a href={link} className="mt-2 btn btn-sm btn-primary uppercase">{count} {t('villas')}</a>
                    </AbsoluteContent>
                </div>
                <div className="mx-3 mx-sm-0">
                    <a href={link} className="btn btn-block btn-secondary mt-3">{t('showvillas')}</a>
                </div>
            </VillaContainer>
        );
    }
}


export const VillaCategoryHolder = withTranslator(VillaCategoryHolderComponent);